import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, inject } from '@angular/core';
import {MotCle} from '../../../interface/api/MotCle';
import {MotCle as CMotCle} from '../../../class/api/MotCle';
import {MatDialog} from '@angular/material/dialog';
import {MotCleTranslation} from '../../../class/api/MotCleTranslation';
import {ModalConfirmationComponent} from '../modal-confirmation/modal-confirmation.component';
import {TranslationService} from '../../services/translation.service';
import {ModalEditMotClesComponent} from './modal-edit-motcles/modal-edit-motcles.component';
import {Subscription} from "rxjs";
import { TranslateService, TranslateModule } from "@ngx-translate/core";

import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-motcles',
    templateUrl: './motcles.component.html',
    styleUrls: ['./motcles.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, TranslateModule]
})
export class MotclesComponent implements OnInit, OnChanges, AfterViewInit {
    private dialog = inject(MatDialog);
    translation = inject(TranslationService);
    translate = inject(TranslateService);

    public labelEn = '';
    public labelFr = '';

    @Input() public motsCles: MotCle[] = [];

    @Input() public required = true;

    @Input() public motCleLangueObligatoire: string = null;

    @Input() public type: string = null;
    @Input() public max: number = 5;

    @Output() add: EventEmitter<MotCle> = new EventEmitter();
    @Output() remove: EventEmitter<MotCle> = new EventEmitter();

    @Output() motClesHasChange: EventEmitter<
        MotCle[]
    > = new EventEmitter();

    public motCleColumns = ['number', 'motCleFr', 'motCleEn', 'action'];

    public motClesTable: any[] = [];

    public subscriptions: Subscription[] = [];
    public messageMotCleLimite = 'motCles.minimum';

    constructor() {
        this.subscriptions.push( this.translate.get(this.messageMotCleLimite).subscribe(res => this.messageMotCleLimite = res.replace('{max}', this.max+'')) );
    }

    public editMotCle(element) {
        this.dialog.open(ModalEditMotClesComponent, {
            width: '740px',
            data: {
                motCle: (element.translations ? element : null),
                listMotCle: this.motsCles
            },
            panelClass: 'arc-dialog-panel', backdropClass: 'arc-dialog-backdrop'
        }).afterClosed().subscribe(res => {
            if(res) {
                if(element.translations) {
                        if(element.translations.length === 0) {
                            const motCleFr = new MotCleTranslation({ locale: 'fr', label: '' });
                            delete motCleFr.id;
                            const motCleEn = new MotCleTranslation({ locale: 'en', label: '' });
                            delete motCleEn.id;
                            element.translations.push(motCleFr, motCleEn);
                        }
                        const motCleTranslationFr = [...element.translations].find((value: MotCleTranslation) => value.locale === 'fr');
                        const motCleTranslationEn = [...element.translations].find((value: MotCleTranslation) => value.locale === 'en');
                        motCleTranslationFr.label = res.motCleFr;
                        motCleTranslationEn.label = res.motCleEn;
                        element.translations = [motCleTranslationFr, motCleTranslationEn];
                        this.add.emit(element);
                        this.motClesHasChange.emit(this.motsCles);
                        this.refreshTable();
                } else {
                    this.addMotCle(res.motCleFr, res.motCleEn);
                }
            }
        });
    }

    addMotCle(labelFr, labelEn) {
        let present = false;
        this.motsCles.forEach(motcle => {
           if(this.translation.getTranslation(motcle, 'fr')?.label == labelFr || this.translation.getTranslation(motcle, 'en')?.label == labelEn) {
               present = true;
           }
        });
        if(present === false) {
            const motCle = new CMotCle();
            delete motCle.id;
            motCle.translations = [];
            const motCleFr = new MotCleTranslation({ locale: 'fr', label: labelFr });
            delete motCleFr.id;
            const motCleEn = new MotCleTranslation({ locale: 'en', label: labelEn });
            delete motCleEn.id;
            motCle.translations.push(motCleFr, motCleEn);
            this.motsCles.push(motCle);
            this.add.emit(motCle);
            this.motClesHasChange.emit(this.motsCles);
        }

    }

    removeMotCle(i: number = null) {
        if (i != null && i != undefined) {
            const confirm = this.dialog.open(ModalConfirmationComponent, {
                panelClass: 'arc-dialog-panel', backdropClass: 'arc-dialog-backdrop'
            });
            confirm.afterClosed().subscribe(res => {
                if (res) {
                    this.motsCles.map((row: MotCle, index) => {
                        if (i === index) {
                            this.motsCles.splice(index, 1);
                            this.remove.emit(row);
                            this.refreshTable();
                            this.motClesHasChange.emit(this.motsCles);
                        }
                    });
                }
            });
        }
    }

    public getMotCles() {
        return this.motsCles;
    }

    public isValid() {
        return this.motsCles.length > 0;
    }

    public isMotCleValid(){
        if(this.motCleLangueObligatoire && this.motCleLangueObligatoire.includes('FR')){
            if(this.labelFr.trim().length==0)
            {
                return false;
            }
        }
        if(this.motCleLangueObligatoire && this.motCleLangueObligatoire.includes('EN')){
            if(this.labelEn.trim().length==0)
            {
                return false;
            }
        }
        return true;
    }

    public noPonctuation(value) {
        return value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ0-9 ]+/g, '');
    }

    public refreshTable() {
        this.motClesTable = [...this.motsCles];
        for( let i = this.motClesTable.length; i < this.max; i++) {
            this.motClesTable.push([]);
        }
    }

    ngOnInit() {
        this.refreshTable();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.motsCles) {
            this.motsCles = changes.motsCles.currentValue;
            this.refreshTable();
        }
    }


    public getMotCleTrans(motCle: MotCle, lang: string): string {
        if(motCle.translations !== null && motCle.translations !== undefined)
        {
            const translated = this.translation.getTranslation(motCle, lang);
            if(translated !== null && translated !== undefined) {
                return translated.label;
            }
        }
        return '';
    }

    ngAfterViewInit(): void {
        /*this.messageMotCleLimite = this.messageMotCleLimite.replace('{max}', this.max+'');
        console.log(this.messageMotCleLimite);*/
    }
}
